import { 
  SET_CURRENT_USER, 
  SET_INTERVAL_ID, 
  UNAUTH_USER, 
  LAST_UPDATE_TIME, 
  SET_TICKER_INFO,
  ADD_USER_ERROR,
} from '../actions/types';
  
  const INIT_STATE = {
    currentUser: '',
    intervalId: null,
    lastUpdateTime: '',
    portfolios: [],
    activePortfolioUser: {},
    isAccountEmpty: null,
    activePortfolioUserList: [],
    printoutDownload: false
  };
  
  export default function (state = INIT_STATE, action) {
    switch (action.type) {
      case SET_TICKER_INFO:
        const { portfolios, activePortfolioUser, isAccountEmpty, 
          activePortfolioUserList } = action.payload.data
        return {
          ...state,
          portfolios,
          activePortfolioUser,
          isAccountEmpty,
          activePortfolioUserList
        };
      case UNAUTH_USER:
        return {
          currentUser: '',
          intervalId: null,
          lastUpdateTime: '',
          portfolios: [],
          activePortfolioUser: {},
          isAccountEmpty: null,
          activePortfolioUserList: [],
          printoutDownload: false
        };
      case LAST_UPDATE_TIME:
        return {
          ...state,
          lastUpdateTime: new Date().toLocaleString()
        };
      case SET_INTERVAL_ID:
        return {
          ...state,
          intervalId: action.payload
        };
      case SET_CURRENT_USER:
        return {
          ...state,
          currentUser: action.payload
        };
      case ADD_USER_ERROR:
        return {
          ...state,
          addUserError: action.payload
        };
      default: return state;
    }
  
  }